export enum RouteNames {
  HOME = "/",
  STRUCTURE = "/project-structure",
  CODE = "/code",
  GIT = "/git",
}
